import React from 'react';
import { OnboardingContext } from './OnboardingContext';

class OnboardingProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      isValid: false,
      isComplete: false,
      forms: [],
      progress: [],
      steps: [],
      resets: [],
      actions: {
        assignTrigger: this.assignTrigger,
        triggerSubmit: this.triggerSubmit,
        setValidState: this.setValidState,
        isValid: this.isValid,
        initSteps: this.initSteps,
        markComplete: this.markComplete,
        reset: this.reset,
        resetAll: this.resetAll,
        setStep: this.setStep
      }
    };
    this.btn = React.createRef();
    this.id = `${props.onboardingType}-on-boarding-flow`;
  }

  render() {
    return (
      <OnboardingContext.Provider value={this.state}>
        {this.props.children}
      </OnboardingContext.Provider>
    );
  }

  assignTrigger = el => (this.btn = el);

  triggerSubmit = () => {
    if (this.btn) this.btn.click();
  };

  isValid = name => {
    const form = this.state.forms.find(form => form.name === name);
    return typeof form !== 'undefined' && 'value' in form && form.value;
  };

  setValidState = (name = 'main', state) => {
    const forms = [...this.state.forms];
    const index = forms.findIndex(form => form.name === name);

    if (index >= 0) forms[index] = { name, value: state };
    else forms.push({ name, value: state });

    const isValid = forms.every(form => form.value === true);
    this.setState({ isValid, forms });
  };

  initSteps = steps => {
    this.setState({ steps });
  };

  markComplete = () => {
    const stepIndex = this.state.currentStep;
    // clone the progress and resets
    let progress = [...this.state.progress];
    let resets = [...this.state.resets];

    if (stepIndex === 0 || stepIndex > 0) {
      // add the current step to progress
      progress = [...new Set([...this.state.progress, stepIndex])];

      // if step has already been completed, update resets
      if (this.state.progress.includes(stepIndex)) {
        const step = this.state.steps[stepIndex];
        const stepResets = step.resets || [];
        if (stepResets) {
          resets = [...new Set([...this.state.resets, ...stepResets])];
        }

        // remove resets from progress
        if (resets) progress = progress.filter(el => resets.indexOf(el) < 0);
      }

      // remove current step from resets
      const i = resets.indexOf(stepIndex);
      if (i !== -1) {
        resets.splice(i, 1);
      }
    }

    this.setState({
      progress,
      resets,
      isComplete: true,
      currentStep: stepIndex + 1
    });
  };

  resetAll = () => this.setState({ currentStep: 0, progress: [], resets: [] });

  reset = () => this.setState({ isComplete: false });

  setStep = currentStep => this.setState({ currentStep });

  componentWillMount() {
    // load from local storage
    const localStorageRef = localStorage.getItem(this.id);
    if (localStorageRef) {
      this.setState(JSON.parse(localStorageRef));
    }
  }

  componentWillUpdate(nextProps, nextState) {
    // save to local storage
    const { progress, resets } = nextState;
    localStorage.setItem(this.id, JSON.stringify({ progress, resets }));
  }
}
export default OnboardingProvider;



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingProvider.js